import { useFindUserDeviceType } from "capitalrx-components-2.0";

import styles from "./DownloadApp.module.scss";

import AndroidStudiosLogo from "../GoogleStoreLogo";
import AppStoreLogo from "../AppleStoreLogo";

interface Props {
  className?: string;
}

const DownloadAppLogo: React.FC<Props> = ({ className }: Props) => {
  const currentDevice = useFindUserDeviceType();

  let appStore = null;
  let androidStore = null;
  let iconClassName;

  if (className) {
    iconClassName = className;
  } else {
    iconClassName = styles.storeIcon;
  }

  if (currentDevice === "iOS" || currentDevice === null) {
    appStore = <AppStoreLogo className={iconClassName} />;
  }

  if (currentDevice === "Android" || currentDevice === null) {
    androidStore = <AndroidStudiosLogo className={iconClassName} />;
  }

  return (
    <>
      <div className={styles.badgeContainer}>
        {appStore}
        {androidStore}
      </div>
    </>
  );
};

export default DownloadAppLogo;
